var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    [
      _c(
        "b-modal",
        {
          attrs: { width: 460, active: _vm.isFormModalActive },
          on: {
            "update:active": function($event) {
              _vm.isFormModalActive = $event
            }
          }
        },
        [
          _c(
            "div",
            { staticClass: "modal-card", staticStyle: { width: "auto" } },
            [
              _c("header", { staticClass: "modal-card-head" }, [
                !_vm.isNew
                  ? _c(
                      "p",
                      { staticClass: "modal-card-title has-text-weight-bold" },
                      [_vm._v(" " + _vm._s(_vm.$t("button.edit")) + " ")]
                    )
                  : _vm._e(),
                _vm.isNew
                  ? _c(
                      "p",
                      { staticClass: "modal-card-title has-text-weight-bold" },
                      [_vm._v(" " + _vm._s(_vm.$t("button.add")) + " ")]
                    )
                  : _vm._e()
              ]),
              _c(
                "section",
                { staticClass: "modal-card-body" },
                [
                  _c(
                    "b-field",
                    {
                      attrs: {
                        label: _vm.$t("label.unit_name"),
                        message: _vm.errors.has("name")
                          ? _vm.$t("messages.field_is_required")
                          : "",
                        type: { "is-danger": _vm.errors.has("name") }
                      }
                    },
                    [
                      _c("b-input", {
                        directives: [
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: "required",
                            expression: "'required'"
                          }
                        ],
                        attrs: { name: "name" },
                        model: {
                          value: _vm.selected.name,
                          callback: function($$v) {
                            _vm.$set(_vm.selected, "name", $$v)
                          },
                          expression: "selected.name"
                        }
                      })
                    ],
                    1
                  ),
                  !_vm.isSupperUnit(_vm.selected)
                    ? _c(
                        "b-field",
                        { attrs: { label: _vm.$t("label.logo") } },
                        [
                          _c(
                            "b-upload",
                            {
                              attrs: { "drag-drop": "" },
                              model: {
                                value: _vm.uploadFile,
                                callback: function($$v) {
                                  _vm.uploadFile = $$v
                                },
                                expression: "uploadFile"
                              }
                            },
                            [
                              _c("section", { staticClass: "section" }, [
                                _c(
                                  "div",
                                  { staticClass: "content has-text-centered" },
                                  [
                                    _c(
                                      "p",
                                      [
                                        _c("b-icon", {
                                          attrs: {
                                            icon: "upload",
                                            size: "is-large"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _c("p", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "messages.drop_file_here_or_select_a_file"
                                          )
                                        )
                                      )
                                    ])
                                  ]
                                )
                              ])
                            ]
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.uploadFile
                    ? _c(
                        "b-field",
                        [
                          _c(
                            "b-tag",
                            {
                              attrs: {
                                size: "is-medium",
                                closable: "",
                                "aria-close-label": "Remove"
                              },
                              on: {
                                close: function($event) {
                                  _vm.uploadFile = null
                                }
                              }
                            },
                            [_vm._v(_vm._s(_vm.uploadFile.name))]
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  !_vm.isSupperUnit(_vm.selected)
                    ? _c(
                        "b-field",
                        {
                          attrs: {
                            label: _vm.$t("label.customer_name"),
                            message: _vm.errors.has("customer_name")
                              ? _vm.$t("messages.field_is_required")
                              : "",
                            type: {
                              "is-danger": _vm.errors.has("customer_name")
                            }
                          }
                        },
                        [
                          _c("b-input", {
                            directives: [
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: "required",
                                expression: "'required'"
                              }
                            ],
                            attrs: { name: "customer_name" },
                            model: {
                              value: _vm.selected.customer_name,
                              callback: function($$v) {
                                _vm.$set(_vm.selected, "customer_name", $$v)
                              },
                              expression: "selected.customer_name"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  !_vm.isSupperUnit(_vm.selected)
                    ? _c(
                        "b-field",
                        { attrs: { label: _vm.$t("label.address") } },
                        [
                          _c("b-input", {
                            attrs: { name: "address" },
                            model: {
                              value: _vm.selected.address,
                              callback: function($$v) {
                                _vm.$set(_vm.selected, "address", $$v)
                              },
                              expression: "selected.address"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  !_vm.isSupperUnit(_vm.selected)
                    ? _c(
                        "b-field",
                        { attrs: { label: _vm.$t("label.token") } },
                        [
                          _c("b-input", {
                            attrs: { name: "token" },
                            model: {
                              value: _vm.selected.token,
                              callback: function($$v) {
                                _vm.$set(_vm.selected, "token", $$v)
                              },
                              expression: "selected.token"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "b-field",
                    {
                      attrs: {
                        label: _vm.$t("label.threshold"),
                        type: { "is-danger": _vm.errors.has("threshold") }
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "message",
                          fn: function() {
                            return _vm._l(
                              _vm.errors.collect("threshold"),
                              function(error, index) {
                                return _c("div", { key: index }, [
                                  _vm._v(_vm._s(error))
                                ])
                              }
                            )
                          },
                          proxy: true
                        }
                      ])
                    },
                    [
                      _c("b-input", {
                        directives: [
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: "required",
                            expression: "'required'"
                          }
                        ],
                        attrs: { type: "number", name: "threshold" },
                        model: {
                          value: _vm.selected.threshold,
                          callback: function($$v) {
                            _vm.$set(_vm.selected, "threshold", $$v)
                          },
                          expression: "selected.threshold"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "b-field",
                    {
                      attrs: { label: _vm.$t("label.domains"), addons: false }
                    },
                    _vm._l(_vm.selected.domains, function(item, index) {
                      return _c(
                        "div",
                        { key: index },
                        [
                          _c(
                            "b-field",
                            {
                              staticClass: "m-b-sm",
                              attrs: {
                                message: _vm.errors.has("domains" + index)
                                  ? _vm.$t("messages.field_is_required")
                                  : "",
                                type: {
                                  "is-danger": _vm.errors.has("domains" + index)
                                }
                              }
                            },
                            [
                              _c(
                                "b-field",
                                {
                                  attrs: {
                                    grouped: "",
                                    type: {
                                      "is-danger": _vm.errors.has(
                                        "domains" + index
                                      )
                                    }
                                  }
                                },
                                [
                                  _c("b-input", {
                                    directives: [
                                      {
                                        name: "validate",
                                        rawName: "v-validate",
                                        value: "required",
                                        expression: "'required'"
                                      }
                                    ],
                                    attrs: {
                                      name: "domains" + index,
                                      expanded: ""
                                    },
                                    model: {
                                      value: _vm.selected.domains[index],
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.selected.domains,
                                          index,
                                          $$v
                                        )
                                      },
                                      expression: "selected.domains[index]"
                                    }
                                  }),
                                  _c("p", { staticClass: "control buttons" }, [
                                    _c(
                                      "button",
                                      {
                                        staticClass: "button",
                                        on: {
                                          click: function($event) {
                                            return _vm.handleAddDomain(index)
                                          }
                                        }
                                      },
                                      [
                                        _c("b-icon", {
                                          attrs: { icon: "plus" }
                                        })
                                      ],
                                      1
                                    ),
                                    _c(
                                      "button",
                                      {
                                        staticClass: "button is-danger",
                                        attrs: {
                                          disabled:
                                            _vm.selected.domains.length === 1
                                        },
                                        on: {
                                          click: function($event) {
                                            return _vm.handleDeleteDomain(index)
                                          }
                                        }
                                      },
                                      [
                                        _c("b-icon", {
                                          attrs: { icon: "minus" }
                                        })
                                      ],
                                      1
                                    )
                                  ])
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    }),
                    0
                  ),
                  _c(
                    "b-field",
                    {
                      attrs: { label: _vm.$t("label.api_keys"), addons: false }
                    },
                    [
                      !_vm.selected.api_keys.length
                        ? _c("b-field", [
                            _c(
                              "button",
                              {
                                staticClass: "button",
                                attrs: { disabled: !_vm.canEdit() },
                                on: {
                                  click: function($event) {
                                    return _vm.handleAddApiKey(-1)
                                  }
                                }
                              },
                              [_c("b-icon", { attrs: { icon: "plus" } })],
                              1
                            )
                          ])
                        : _vm._e(),
                      _vm._l(_vm.apiKeys, function(item, api_key_index) {
                        return _c(
                          "div",
                          { key: api_key_index },
                          [
                            _c(
                              "b-field",
                              { staticClass: "m-b-sm" },
                              [
                                _c(
                                  "b-field",
                                  { attrs: { grouped: "" } },
                                  [
                                    _c(
                                      "p",
                                      { staticClass: "control" },
                                      [
                                        _c(
                                          "b-select",
                                          {
                                            attrs: {
                                              name: "api_key_access_right"
                                            },
                                            model: {
                                              value:
                                                _vm.selected.api_keys[
                                                  api_key_index
                                                ].access_right,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.selected.api_keys[
                                                    api_key_index
                                                  ],
                                                  "access_right",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "selected.api_keys[api_key_index].access_right"
                                            }
                                          },
                                          _vm._l(
                                            _vm.apiKeyAccessRightOptions,
                                            function(access_right_item, index) {
                                              return _c(
                                                "option",
                                                {
                                                  key: index,
                                                  domProps: {
                                                    value:
                                                      access_right_item.code
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm.$t(
                                                          access_right_item.label
                                                        )
                                                      ) +
                                                      " "
                                                  )
                                                ]
                                              )
                                            }
                                          ),
                                          0
                                        )
                                      ],
                                      1
                                    ),
                                    _c("b-input", {
                                      attrs: {
                                        expanded: "",
                                        readonly: "",
                                        name: "api_key" + api_key_index
                                      },
                                      model: {
                                        value:
                                          _vm.selected.api_keys[api_key_index]
                                            .api_key,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.selected.api_keys[
                                              api_key_index
                                            ],
                                            "api_key",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "selected.api_keys[api_key_index].api_key"
                                      }
                                    }),
                                    _c(
                                      "p",
                                      { staticClass: "control buttons" },
                                      [
                                        _c(
                                          "button",
                                          {
                                            staticClass: "button",
                                            attrs: { disabled: !_vm.canEdit() },
                                            on: {
                                              click: function($event) {
                                                return _vm.handleAddApiKey(
                                                  api_key_index
                                                )
                                              }
                                            }
                                          },
                                          [
                                            _c("b-icon", {
                                              attrs: { icon: "plus" }
                                            })
                                          ],
                                          1
                                        ),
                                        _c(
                                          "button",
                                          {
                                            staticClass: "button is-danger",
                                            attrs: { disabled: !_vm.canEdit() },
                                            on: {
                                              click: function($event) {
                                                return _vm.handleDeleteApiKey(
                                                  api_key_index
                                                )
                                              }
                                            }
                                          },
                                          [
                                            _c("b-icon", {
                                              attrs: { icon: "minus" }
                                            })
                                          ],
                                          1
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      })
                    ],
                    2
                  ),
                  _c(
                    "b-field",
                    { attrs: { label: _vm.$t("label.db_name") } },
                    [
                      _c("b-input", {
                        attrs: { disabled: "" },
                        model: {
                          value: _vm.selected.db_name,
                          callback: function($$v) {
                            _vm.$set(_vm.selected, "db_name", $$v)
                          },
                          expression: "selected.db_name"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c("footer", { staticClass: "modal-card-foot" }, [
                _c(
                  "button",
                  {
                    staticClass: "button has-text-weight-semibold",
                    on: {
                      click: function($event) {
                        _vm.isFormModalActive = false
                      }
                    }
                  },
                  [_vm._v(" " + _vm._s(_vm.$t("button.cancel")) + " ")]
                ),
                _c(
                  "button",
                  {
                    staticClass: "button is-primary has-text-weight-bold",
                    on: {
                      click: function($event) {
                        return _vm.handleApplyChange()
                      }
                    }
                  },
                  [_vm._v(" " + _vm._s(_vm.buttonSaveText) + " ")]
                )
              ])
            ]
          )
        ]
      ),
      _c("nav", { staticClass: "level" }, [
        _c("div", { staticClass: "level-left" }, [
          _c(
            "div",
            { staticClass: "level-item" },
            [
              _c(
                "b-select",
                {
                  attrs: { disabled: !_vm.isPaginated },
                  model: {
                    value: _vm.perPage,
                    callback: function($$v) {
                      _vm.perPage = $$v
                    },
                    expression: "perPage"
                  }
                },
                [
                  _c("option", { attrs: { value: "5" } }, [_vm._v("5")]),
                  _c("option", { attrs: { value: "10" } }, [_vm._v("10")]),
                  _c("option", { attrs: { value: "20" } }, [_vm._v("20")]),
                  _c("option", { attrs: { value: "50" } }, [_vm._v("50")]),
                  _c("option", { attrs: { value: "100" } }, [_vm._v("100")])
                ]
              ),
              _c("span", { staticClass: "p-l-sm" }, [
                _vm._v(_vm._s(_vm.$t("pagination.per_page")))
              ])
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "level-item" },
            [
              _c(
                "b-select",
                {
                  attrs: { disabled: !_vm.isPaginated },
                  model: {
                    value: _vm.currentPage,
                    callback: function($$v) {
                      _vm.currentPage = $$v
                    },
                    expression: "currentPage"
                  }
                },
                _vm._l(_vm.numofPage, function(index) {
                  return _c(
                    "option",
                    { key: index, domProps: { value: index } },
                    [_vm._v(" " + _vm._s(index) + " ")]
                  )
                }),
                0
              ),
              _c("span", { staticClass: "p-l-sm" }, [
                _vm._v(_vm._s(_vm.$t("pagination.of_pages")))
              ])
            ],
            1
          )
        ]),
        _c("div", { staticClass: "level-right" }, [
          _c("div", { staticClass: "level-item" }, [
            _c(
              "div",
              { staticClass: "control" },
              [
                _c(
                  "b-field",
                  [
                    _c(
                      "p",
                      { staticClass: "control" },
                      [
                        _c(
                          "b-dropdown",
                          {
                            model: {
                              value: _vm.selectedFilter,
                              callback: function($$v) {
                                _vm.selectedFilter = $$v
                              },
                              expression: "selectedFilter"
                            }
                          },
                          [
                            _c(
                              "button",
                              {
                                staticClass: "button",
                                attrs: { slot: "trigger" },
                                slot: "trigger"
                              },
                              [
                                _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.convertFieldName(_vm.selectedFilter)
                                    )
                                  )
                                ]),
                                _c("b-icon", { attrs: { icon: "menu-down" } })
                              ],
                              1
                            ),
                            _c(
                              "b-dropdown-item",
                              { attrs: { value: "name" } },
                              [_vm._v(_vm._s(_vm.$t("label.unit_name")))]
                            ),
                            _c(
                              "b-dropdown-item",
                              { attrs: { value: "customer_name" } },
                              [_vm._v(_vm._s(_vm.$t("label.customer_name")))]
                            ),
                            _c(
                              "b-dropdown-item",
                              { attrs: { value: "address" } },
                              [_vm._v(_vm._s(_vm.$t("label.address")))]
                            ),
                            _c(
                              "b-dropdown-item",
                              { attrs: { value: "token" } },
                              [_vm._v(_vm._s(_vm.$t("label.token")))]
                            ),
                            _c(
                              "b-dropdown-item",
                              { attrs: { value: "timezone" } },
                              [_vm._v(_vm._s(_vm.$t("label.timezone")))]
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c("b-input", {
                      attrs: {
                        icon: "magnify",
                        type: "search",
                        placeholder: _vm.$t("label.search_placeholder")
                      },
                      model: {
                        value: _vm.searchQuery,
                        callback: function($$v) {
                          _vm.searchQuery = $$v
                        },
                        expression: "searchQuery"
                      }
                    })
                  ],
                  1
                )
              ],
              1
            )
          ]),
          _c("div", { staticClass: "level-item buttons" }, [
            _vm.canEdit()
              ? _c(
                  "button",
                  {
                    staticClass: "button is-primary",
                    on: {
                      click: function($event) {
                        return _vm.handleOpenModalAdd()
                      }
                    }
                  },
                  [
                    _c("b-icon", { attrs: { icon: "plus" } }),
                    _c("span", [_vm._v(_vm._s(_vm.$t("button.add")))])
                  ],
                  1
                )
              : _vm._e(),
            _c("button", { staticClass: "button" }, [
              _c(
                "span",
                [
                  _c(
                    "download-csv",
                    {
                      attrs: {
                        data: _vm.units,
                        fields: _vm.csvFields,
                        name: "units.csv"
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("button.export_csv")))]
                  )
                ],
                1
              )
            ])
          ])
        ])
      ]),
      _c(
        "b-table",
        {
          attrs: {
            data: _vm.isLoading ? [] : _vm.filteredData,
            narrowed: true,
            paginated: _vm.isPaginated,
            "per-page": _vm.perPage,
            striped: true,
            hoverable: true,
            "current-page": _vm.currentPage,
            "pagination-simple": _vm.isPaginationSimple,
            "pagination-position": _vm.paginationPosition,
            "default-sort-direction": _vm.defaultSortDirection,
            "sort-icon-size": _vm.sortIconSize,
            "aria-next-label": "Next page",
            "aria-previous-label": "Previous page",
            "aria-page-label": "Page",
            "aria-current-label": "Current page",
            "row-class": function(row) {
              return _vm.isSupperUnit(row) && "is-selected"
            }
          },
          on: {
            "update:currentPage": function($event) {
              _vm.currentPage = $event
            },
            "update:current-page": function($event) {
              _vm.currentPage = $event
            }
          }
        },
        [
          _vm._t("columns"),
          _c("b-table-column", {
            attrs: { field: "name", label: _vm.$t("label.logo"), width: "150" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(props) {
                  return [
                    props.row.logo
                      ? _c("img", { attrs: { src: props.row.logo } })
                      : _vm._e()
                  ]
                }
              }
            ])
          }),
          _c("b-table-column", {
            attrs: {
              field: "name",
              label: _vm.$t("label.unit_name"),
              sortable: ""
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(props) {
                  return [
                    _c(
                      "router-link",
                      {
                        attrs: {
                          to: {
                            name: "unit_detail",
                            params: { unit_id: props.row._id }
                          }
                        }
                      },
                      [_vm._v(_vm._s(props.row.name || "-"))]
                    )
                  ]
                }
              }
            ])
          }),
          _c("b-table-column", {
            attrs: {
              field: "customer_name",
              label: _vm.$t("label.customer_name"),
              sortable: ""
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(props) {
                  return [_vm._v(_vm._s(props.row.customer_name || "-"))]
                }
              }
            ])
          }),
          _c("b-table-column", {
            attrs: {
              field: "numof_operators",
              label: _vm.$t("label.numof_operators"),
              sortable: ""
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(props) {
                  return [_vm._v(_vm._s(props.row.numof_operators || "-"))]
                }
              }
            ])
          }),
          _c("b-table-column", {
            attrs: {
              field: "address",
              label: _vm.$t("label.address"),
              sortable: ""
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(props) {
                  return [_vm._v(_vm._s(props.row.address || "-"))]
                }
              }
            ])
          }),
          _c("b-table-column", {
            attrs: {
              field: "timezone",
              label: _vm.$t("label.timezone"),
              sortable: ""
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(props) {
                  return [_vm._v(_vm._s(props.row.timezone || "-"))]
                }
              }
            ])
          }),
          _c("b-table-column", {
            attrs: {
              field: "token",
              label: _vm.$t("label.token"),
              sortable: ""
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(props) {
                  return [
                    _vm._v(
                      _vm._s(
                        !_vm.isSupperUnit(props.row)
                          ? props.row.token || "-"
                          : "-"
                      )
                    )
                  ]
                }
              }
            ])
          }),
          _c("b-table-column", {
            attrs: {
              field: "domains",
              label: _vm.$t("label.domains"),
              sortable: ""
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(props) {
                  return _vm._l(props.row.domains, function(domain, index) {
                    return _c(
                      "div",
                      { key: index },
                      [
                        _c("b-tag", { attrs: { type: "is-dark" } }, [
                          _vm._v(_vm._s(domain))
                        ])
                      ],
                      1
                    )
                  })
                }
              }
            ])
          }),
          _c("b-table-column", {
            attrs: { field: "is_active", label: _vm.$t("label.status") },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(props) {
                  return [
                    _c(
                      "b-field",
                      [
                        _c(
                          "b-switch",
                          {
                            attrs: { type: "is-info" },
                            on: {
                              input: function($event) {
                                return _vm.doApplyChangeStatus(props.row)
                              }
                            },
                            model: {
                              value: props.row.is_active,
                              callback: function($$v) {
                                _vm.$set(props.row, "is_active", $$v)
                              },
                              expression: "props.row.is_active"
                            }
                          },
                          [
                            props.row.is_active
                              ? _c("span", [_vm._v("ON")])
                              : _c("span", [_vm._v("OFF")])
                          ]
                        )
                      ],
                      1
                    )
                  ]
                }
              }
            ])
          }),
          _c("b-table-column", {
            attrs: { field: "unit_detail" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(props) {
                  return [
                    _c(
                      "router-link",
                      {
                        attrs: {
                          to: {
                            name: "unit_detail",
                            params: { unit_id: props.row._id }
                          }
                        }
                      },
                      [_vm._v(_vm._s(_vm.$t("label.detail")))]
                    )
                  ]
                }
              }
            ])
          }),
          !_vm.isLoading
            ? _c("template", { slot: "empty" }, [_c("NotFound")], 1)
            : _vm._e()
        ],
        2
      ),
      _c("b-loading", {
        attrs: { "is-full-page": true, active: _vm.isLoading },
        on: {
          "update:active": function($event) {
            _vm.isLoading = $event
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }